module.exports = __webpack_public_path__ + "static/media/tabela.39b2d9d1.png";